const languageDropdown = [
  { name: "English", lngValue: "en" },
  { name: "עִברִית", lngValue: "he" },
];

const growerTableHeader = [
  {
    name: "Grower Name",
  },
  {
    name: "Location",
  },
  {
    name: "Phone Number",
  },
  {
    name: "Action",
  },
];
const scoutingTableHeader = [
  {
    name: "Fields",
  },

  {
    name: "Year",
  },

  {
    name: "Action",
  },
];
// const felidTableHeader = [
//   {
//     name: "Field",
//   },
//   {
//     name: "Acres",
//   },
//   {
//     name: "2025(Current)",
//   },
//   {
//     name: "Action",
//   },
// ];

const felidTableHeader = (data) => {
  const allYears = data.flatMap((field) =>
    field.seasons?.map((season) => season.year)
  );

  const uniqueYears = [...new Set(allYears)].sort(
    (a, b) => Number(b) - Number(a)
  );
  // const currentYear = new Date().getFullYear().toString();

  const fieldTableHeader = [{ name: "Field" }, { name: "Acres" }];

  uniqueYears.forEach((year) => {
    // const label = year === currentYear ? `${year} current` : year;
    const label = year;
    fieldTableHeader.push({ name: label });
  });

  fieldTableHeader.push({ name: "Action" });

  return fieldTableHeader;
};

const cropPlanTableHeader = [
  {
    name: "Growing Session",
  },
  { name: "Description" },
  // { name: "Status" },
  {
    name: "Action",
  },
];
const scoutingModalHeader = (year) => {
  return [
    {
      name: "Field",
    },
    {
      name: `Crop ${year}`,
    },
    {
      name: "Acres",
    },
    {
      name: "Select",
    },
  ];
};
const scoutingModalStep2Header = [
  {
    name: "Field",
  },
  {
    name: "Crop",
  },
  {
    name: "Acres",
  },
];

const dataCountOption = [
  {
    id: "1",
    page: "5",
  },
  {
    id: "2",
    page: "10",
  },
  {
    id: "3",
    page: "20",
  },
  {
    id: "4",
    page: "30",
  },
];

export {
  languageDropdown,
  growerTableHeader,
  dataCountOption,
  scoutingTableHeader,
  cropPlanTableHeader,
  scoutingModalHeader,
  scoutingModalStep2Header,
  felidTableHeader,
};
